import { createServerFn } from '@tanstack/react-start';
import { env } from 'env';

export type PublicEnv = {
  WEBSITE_URL: string;
  FACEBOOK_APPID: string;
  GOOGLE_BROWSER_APIKEY: string;
  PUSHER_APP_KEY: string;
  POSTHOG_API_KEY: string;
  INTERCOM_APP_ID: string;
  GOOGLE_ANALYTICS_MEASUREMENT_ID: string;
  GOOGLE_TAG_MANAGER_CONTAINER_ID: string;
  SEGMENT_WRITE_KEY: string;
  FIRST_PARTY_ANALYTICS_WRITE_KEY: string;
  FIRST_PARTY_ANALYTICS_HOST: string;
  ENVIRONMENT: 'local' | 'staging' | 'production' | 'qa' | 'development';
  RECAPTCHA_V3_SITE_KEY: string;
  RECAPTCHA_V2_SITE_KEY: string;
};

export const getPublicEnv = createServerFn().handler(
  (): PublicEnv => ({
    WEBSITE_URL: env.WEBSITE_URL,
    FACEBOOK_APPID: env.FACEBOOK_APPID,
    GOOGLE_BROWSER_APIKEY: env.GOOGLE_BROWSER_APIKEY,
    PUSHER_APP_KEY: env.PUSHER_APP_KEY,
    POSTHOG_API_KEY: env.POSTHOG_API_KEY,
    INTERCOM_APP_ID: env.INTERCOM_APP_ID,
    GOOGLE_ANALYTICS_MEASUREMENT_ID: env.GOOGLE_ANALYTICS_MEASUREMENT_ID,
    GOOGLE_TAG_MANAGER_CONTAINER_ID: env.GOOGLE_TAG_MANAGER_CONTAINER_ID,
    SEGMENT_WRITE_KEY: env.SEGMENT_WRITE_KEY,
    FIRST_PARTY_ANALYTICS_WRITE_KEY: env.FIRST_PARTY_ANALYTICS_WRITE_KEY,
    FIRST_PARTY_ANALYTICS_HOST: env.FIRST_PARTY_ANALYTICS_HOST,
    ENVIRONMENT: env.ENVIRONMENT,
    RECAPTCHA_V3_SITE_KEY: env.RECAPTCHA_V3_SITE_KEY,
    RECAPTCHA_V2_SITE_KEY: env.RECAPTCHA_V2_SITE_KEY,
  }),
);
